import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { getCompanyPlaceList } from "../../utility/service/carbon-service";
import { getCompanyOfferingList } from "../../utility/service/companyOffering-service";
import { checkDpSuccess, getCompanyType } from "../../utility/service/tool-service";

const CompanyOffering_Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    itemObj,
    setItemObj,
    action,
    setAction,
    currentStatus,
    setCurrentStatus,
    currentComSeq,
    setCurrentComSeq,
    currentCompanyName, setCurrentCompanyName
  } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [, loading] = useContext(SystemLoading);
  const [offeringsId, setOfferingsId] = useState(""); //分頁PK
  const [isLoading, setIsLoading] = useState(false);
  const [companyPlaceList, setCompanyPlaceList] = useState([]);
  const [tooltipTarget, setTooltipTarget] = useState(null);
  const isEditable = useEditableFlag("F10404"); // Get editable status for F10404 function

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      keywordSearch: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const onSubmit = (data) => {
    axios_getCompanyOfferingList({
      companySeq: data.companySeq,
      keywordSearch: data.keywordSearch,
    });
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  const btnReadMore = () => {
    axios_getCompanyOfferingList(
      {
        companySeq: getValues("companySeq"),
        keywordSearch: getValues("keywordSearch"),
        offeringsId: offeringsId,
      },
      true
    );
  };

  const btnCreate = () => {
    setItemObj({});
    setAction("create");
    navigate("create");
  };

  const editItem = (item) => {
    setItemObj(item);
    setAction("detail");
    navigate("detail");
  };

  useEffect(() => {
    axios_getCompanyPlaceList();
  }, []);

  const axios_getCompanyOfferingList = (reqBody, readMore = false) => {
    checkLoading(loading);
    getCompanyOfferingList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody?.companiesProduct;
          if (data?.length > 0) {
            setOfferingsId(
              res.data.RespBody.companiesProduct[res.data.RespBody.companiesProduct?.length - 1].offeringsId
            );

            if (readMore === true) {
              setRows((pre) => {
                return [...pre, ...data];
              });
            } else {
              setRows((pre) => {
                return [...data];
              });
            }
          } else {
            if (readMore === false) {
              setRows([]);
            }
          }
        } else {
          if (readMore === false) {
            setRows([]);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  //組織邊界廠商清單
  const axios_getCompanyPlaceList = () => {
    // checkLoading(loading);
    setIsLoading(true);
    getCompanyPlaceList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.companyPlaceList;
          setCompanyPlaceList(data);
          if (getCompanyType() === "A") {
            setValue("companySeq", data[0].companySeq);
            trigger("companySeq");
            setValue("companyName", data[0].companyName);
            setCurrentComSeq(data[0].companySeq); //紀錄目前所選的廠商名稱
            setCurrentCompanyName(data[0].companyName);
            axios_getCompanyOfferingList({
              companySeq: data[0].companySeq,
            });
          } else {
            if (currentComSeq !== "") {
              let reqBody = {
                companySeq: currentComSeq,
              };
              setValue("companySeq", currentComSeq);
              trigger("companySeq");
              axios_getCompanyOfferingList(reqBody);
            }
          }
        }
      })
      .finally(() => {
        // checkLoading(loading, false)
        setIsLoading(false);
      });
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t("button.detail")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
        </>
      );
    }
  };

  const enableFlagBodyTemplate = (rowData) => {
    if (rowData) {
      return <Tag severity={rowData.enableFlag === "Y" ? "success" : "danger"} value={rowData?.enableFlagName}></Tag>;
    }
  };

  const pNameBodyTemplate = (rowData, props) => {
    const tooltipContent = rowData?.[props?.field];
    if (rowData) {
      return (
        <span
          ref={(el) => setTooltipTarget(el)}
          data-pr-tooltip={tooltipContent}
          data-pr-position="bottom"
          className="nameBody text-ellipsis"
        >
          {tooltipContent}
        </span>
      );
    }
  };

  const CNcodeBodyTemplate = (rowData, props) => {
    const tooltipContent = rowData?.[props?.field];
    if (rowData) {
      return (
        <span
          ref={(el) => setTooltipTarget(el)}
          data-pr-tooltip={rowData?.cnCodeName}
          data-pr-position="bottom"
          className="nameBody text-ellipsis"
        >
          {tooltipContent}
        </span>
      );
    }
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form className="grid" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
            <div className="col-12 lg:col-4">
              <label htmlFor="companySeq" className="form-label required">
                {t("organName")}
              </label>
              <Controller
                name="companySeq"
                control={control}
                rules={{ required: { value: true, message: t("validation.required") } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    optionLabel="companyName"
                    optionValue="companySeq"
                    value={field.value}
                    disabled={getCompanyType() === "A"}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="companySeq"
                    control={control}
                    options={companyPlaceList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      setCurrentComSeq(event.value);
                      setCurrentCompanyName(companyPlaceList.find(item => item.companySeq === event.value)?.companyName);
                    }}
                  />
                )}
              />
            </div>

            <div className="col-12 lg:col-8">
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={`${t("productName")}、${t("enName")}、HS Code、CN Code`}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t("keyword")}
              />
            </div>

            <div className="col-12 gap-2 flex-all-center">
              {/* 查詢 */}
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
              {/* 新增 */}
              <Button
                outlined
                disabled={!isValid}
                onClick={() => {
                  btnCreate();
                }}
                type="button"
                label={t("button.create")}
              />
            </div>
          </form>
        </div>
      </div>

      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            value={rows}
            tableStyle={{ minWidth: "40rem" }}
            footer={
              rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            <Column
              body={pNameBodyTemplate}
              style={{ minWidth: "150px", maxWidth: "200px" }}
              field="productName"
              header={t("productName")}
            />
            <Column body={pNameBodyTemplate} style={{ minWidth: "150px" }} field="productEName" header={t("enName")} />
            <Column style={{ minWidth: "100px" }} field="productTypeName" header={t("type")} />
            <Column field="hsCode" header="HS Code" />
            <Column style={{ minWidth: "150px" }} body={CNcodeBodyTemplate} field="cnCode" header="CN Code" />
            <Column
              style={{ minWidth: "120px" }}
              body={enableFlagBodyTemplate}
              field="enableFlagName"
              header={t("status")}
            />
            <Column
              style={{ minWidth: "170px" }}
              body={actionBodyTemplate}
              header={t("action")}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      {tooltipTarget && <Tooltip mouseTrack target=".nameBody" position="bottom" event="hover" />}
    </>
  );
};

export default CompanyOffering_Index;
